import script from "./ChatSearchList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSearchList.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSearchList.vue?vue&type=style&index=0&id=514f3a27&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514f3a27"]])

export default __exports__